/* file description */
import { create, StateCreator } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { ModuleInfo } from '@/common/model-apis/type';
import { EmitEventType, MetaInfo, MetaState } from './type';
import StoreContext from './context';
import { useSetState } from 'ahooks';
import { useContext, useRef } from 'react';
import { EventType } from '@/asset/types';
import _ from 'lodash';
import { useEventCenter } from '../asset/AssetTask/templates/Cascade/effect/useEventCenter';
import { isMobileEnv } from '@/utils';


export const useMeta = function (): MetaState {
  const eventsRef = useRef<EventType[]>([]);
  const [state, setState] = useSetState<MetaInfo>({
    moduleList: [],
    taskId: '',
    utils: {},
    recordId: '',
    taskInfo: undefined,
    pageConfig: undefined,
    pageType: 'add',
    moduleTaskField: undefined,
    metaInfoByRule: {},
    eventsConfig: {},
    isMobile: isMobileEnv(),
  });


  return {
    ...state,
    events: eventsRef,
    setMetaInfo: (value) => {
      setState(value);
    },
    dispatchEvent: (events: EventType[], destroy = false) => {
      const regIds: string[] = [];
      const newEv = events.map((item) => {
        if ((!item.code || !item.fieldName) && !item.id) return;
        const id = _.uniqueId('event_');
        regIds.push(id);
        return {
          ...item,
          id,
        };
      }).filter((item) => item !== undefined);

      /** 示例
        const events = [{
          code:'test',
          name: '测试',
          touchConfig: 'change',
          actionType: 'callback',
          moduleName: 'ltc_customer_order_basic_info',
          fieldName: 'ltc_contract_basic_info_id',
          fun: (value) => {
            console.log(value, 'sam---------');
          },
        }];
       */
      if (!destroy) {
        const oldEv = _.cloneDeep(eventsRef.current);
        eventsRef.current = [...oldEv, ...newEv];
      } else {
        eventsRef.current = [...newEv];
      }
      return regIds;
    },
    destroyEvent: (eventsIds: string[]) => {
      const ids = eventsIds.filter((item) => item !== undefined);
      // const filterEv = eventsRef.current.map((ev) => {
      //   if (!ids.includes(ev!.id) || !ids.includes(ev!.code)) {
      //     return ev;
      //   }
      // }).filter((item) => item !== undefined);
      const filterEv = eventsRef.current.filter((ev) => {
        if (ev.id && ids.includes(ev.id)) return false;
        if (ev.code && ids.includes(ev.code)) return false;
        return true;
      });
      // console.log('删除后Ev: ', filterEv);
      eventsRef.current = filterEv as EventType[];
    },
    /**
     * 触发事件 eventsIds 和 moduleName、fieldName给出一个就可以
     * @param eventsIds id 或者 code 的数组
     * @param value 当前改变的值
     * @param moduleName 模型名称
     * @param rowIndex 当前行的index值
     * @param touchConfig  'change' | 'click'
     * @param type 当前时间触发的轻重程度，'light'轻程度，如果不传着执行重程度触发
     * @param params 自己传递进来的回调中也能拿到到
     */
    emitEvent: ({ eventsIds, value, moduleName, fieldName, rowIndex, touchConfig, type, params, isFormCopyValue }: EmitEventType) => {
      let eventStack: EventType[] = [];
      // 传入id,优先以id为主
      if (eventsIds) {
        eventStack = eventsRef.current.map((ev) => {
          if (eventsIds.includes(ev!.id) || eventsIds.includes(ev!.code)) {
            return ev;
          }
        }).filter((item) => item !== undefined);
      } else {
        // 1.根据模型字段过滤
        eventStack = eventsRef?.current?.filter((e) => (e?.moduleName === moduleName && e?.fieldName === fieldName)) || [];
        // 2.根据触发动作过滤
        eventStack = eventStack.filter((e) => e.touchConfig === touchConfig);
        // 3.根据rowIndex过滤
        if (rowIndex !== null || rowIndex !== undefined || rowIndex === '*') {
          eventStack = eventStack?.filter((e) => (e.rowIndex === '*' || e.rowIndex === rowIndex)) || [];
        }
      }
      eventStack?.forEach((event) => {
        event?.fun && event?.fun(value, { rowIndex, event, type, params, isFormCopyValue });
      });
    },

  };
};

const useMetaStore = () => {
  const store = useContext(StoreContext);
  return store.meta;
};

export default useMetaStore;
